module.exports = __webpack_public_path__ + "static/media/referral.0311063d.svg";